export default "__VITE_ASSET__ChMHLMca__"